/* @flow */
import React from 'react';
import Tooltip from 'components/Tooltip.jsx';
import LayerPropTypes from 'components/lib/LayerPropTypes';
import TooltipTrigger from 'components/TooltipTrigger.jsx';

/* ************************************** */
/* DEPRECATED: Use TooltipTrigger instead */
/* ************************************** */

export const tooltipablePropTypes = {
  tooltip: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.element,
    React.PropTypes.instanceOf(Tooltip),
  ]),
  tooltipPlacement: LayerPropTypes.placement,
  tooltipAlignment: LayerPropTypes.alignment,
};

/* HOC
 *
 * Make any component tooltip ready
 * this mean any parent component can add tooltip to
 * the wrapper component by passing a tooltip prop to it.
 */
// typecheck: ignore statement
export default function tooltipable(Component: Function) {
  class Wrapper extends React.Component {
    static propTypes = tooltipablePropTypes;
    static displayName = Component.displayName || Component.name;

    render() {
      const {
        tooltip,
        tooltipPlacement,
        tooltipAlignment,
        ...rest
      } = this.props;

      if (!tooltip) {
        return <Component {...this.props} />;
      }

      return (
        <TooltipTrigger
          tooltip={tooltip}
          placement={tooltipPlacement}
          alignment={tooltipAlignment}>
          <Component {...rest} />
        </TooltipTrigger>
      );
    }
  }

  return Wrapper;
}



// WEBPACK FOOTER //
// ./src/lib/tooltipable.js